import type { PropsWithChildren } from "react"
import { ModalProvider } from "src/context/modal/ModalProvider"
import { ScrollRestorationProvider } from "src/context/scrollRestoration/ScrollRestorationProvider"

export const Root = ({ children }: PropsWithChildren) => (
	<ModalProvider root={document.querySelector("#root") ?? document.body}>
		<ScrollRestorationProvider>{children}</ScrollRestorationProvider>
	</ModalProvider>
)
